import axiosInstance from "./AxiosInstance";

export function getVehicleCheckList(data) {
  return axiosInstance.post(`vehicle-checklist/list`, data);
}

export function createVehicleCheckList(data) {
  return axiosInstance.post(`vehicle-checklist/create`, data);
}

export function updateVehicleCheckList(data) {
  return axiosInstance.post(`vehicle-checklist/update`, data);
}

export function deleteVehicleCheckList(data) {
  return axiosInstance.post(`vehicle-checklist/delete`, data);
}
